var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTriangleDown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 856 512",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M371.4,472.6c31.2,31.2,82,31.2,113.2,0l319.9-319.9c23-23,29.7-57.2,17.2-87.2c-12.5-30-41.5-49.5-74-49.5L108,16.3 c-32.2,0-61.5,19.5-74,49.5s-5.5,64.2,17.2,87.2l319.9,319.9L371.4,472.6z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTriangleDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/TriangleDown.170148cb0902f6dd4f59a738277d8447.svg";